import { Pagination, PaginationProps } from 'oskcomponents';
import React from 'react';

import { SHORT_VISIBLE_PAGE_SIZE } from '~/pagination';

export type OrdersAdminPaginatorProps = {
    /** Total count of visible catalog items */
    totalOrders?: number;
    /** Current page for pagination from redux */
    currentPage?: number;
    /** Event that fires when the user initiates a page change */
    changePage?: (pageNumber: number) => void;
} & Omit<PaginationProps, 'offset'>;

const OrdersAdminPaginator = ({ totalOrders, currentPage, changePage, ...props }: OrdersAdminPaginatorProps) => {
    if (!totalOrders || totalOrders < SHORT_VISIBLE_PAGE_SIZE) return <></>;

    return (
        <Pagination
            inverted
            style={{
                borderRadius: '0px',
                margin: '0px -14px -14px -14px',
                padding: '14px',
            }}
            onChange={changePage}
            count={totalOrders ?? 0}
            pageSize={SHORT_VISIBLE_PAGE_SIZE}
            offset={(currentPage ?? 0) * SHORT_VISIBLE_PAGE_SIZE}
            {...props}
        />
    );
};

export default OrdersAdminPaginator;
